import i18n from "i18next";
import { initReactI18next } from 'react-i18next';
import { LANGUAGE_DEFAULT } from './consts/data'
import plTranslation from './locales/pl/translation.json'
import enTranslation from './locales/en/translation.json'
import deTranslation from './locales/de/translation.json'

i18n.use(initReactI18next).init({
    resources: {
        de: { translation: deTranslation },
        en: { translation: enTranslation },
        pl: { translation: plTranslation },
    },
    lng: LANGUAGE_DEFAULT,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    }
});

export default i18n;
